/* eslint-disable import/no-cycle */
import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Slider, { Settings, CustomArrowProps } from 'react-slick';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import { AppsI } from '../..';
import colorContext from '../../../../Context/colorContext';

interface Props {
  listApps: AppsI;
}

export default function Apps({ listApps }: Props): JSX.Element {
  const { colors } = useContext(colorContext);
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '80px 5px',
      flexDirection: 'column',
    },
    card: {
      // position: 'relative',
      // marginBottom: 10,
      // marginLeft: 5,
      // marginRight: 5,
      borderRadius: 4,
      boxShadow: 'none',
      textTransform: 'capitalize',
      marginTop: 10,
      height: 155,
      // minWidth: 160,
      color: colors.accentColor,
      fontSize: theme.typography.pxToRem(18),
      backgroundColor: colors.colorBackgroundSecundary,
      '&:hover': {
        boxShadow: '0px 12px 42px -4px rgba(24, 39, 75, 0.12)',
        backgroundColor: colors.colorBackground,
      },
    },
    button: {
      border: `1px solid ${colors.textAccentColor}`,
      minWidth: 0,
      marginBottom: 10,
      padding: '8px 35px',
      borderRadius: 5,
      '&:hover': {
        background: colors.colorBackgroundSecundary,
        color: colors.accentColor,
      },
    },
    IconNavite: {
      color: colors.accentColor,
      width: 44,
      height: 44,
      border: `1px solid ${colors.accentColor}`,
      borderRadius: '4px 4px 4px 4px',
      '&:hover': {
        backgroundColor: colors.cardAccentColor,
        color: colors.textAccentColor,
      },
      '& .MuiIconButton-label': {
        width: 'auto',
      },
    },
    icon: {
      width: 24,
      height: 24,
    },
    contentLegend: {
      display: 'flex',
      flex: 1,
      width: '100%',
      alignItems: 'center',
      backgroundColor: colors.colorBackground,
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    barSeparate: {
      width: '100%',
      height: 0,
      border: '0.5px solid #555555',
      margin: '0px 5px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    textLegend: {
      color: colors.textBody,
      fontFamily: 'Roboto',
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(32),
      minWidth: 'fit-content',
      margin: '0px 9px',
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(30),
        textAlign: 'center',
      },
    },
    textInfo: {
      fontSize: theme.typography.pxToRem(18),
      color: colors.accentColor,
      textAlign: 'center',
      backgroundColor: colors.colorBackground,
    },
    slider: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    carroselArea: {
      width: '75%',
      backgroundColor: colors.colorBackground,
    },
  }));
  const classes = useStyles();
  const [appSelected, setAppSelected] = useState<number | null>();

  const NextArrow = ({ onClick, style }: CustomArrowProps): JSX.Element => (
    <IconButton
      className={classes.IconNavite}
      color="primary"
      onClick={onClick}
      style={{
        display: 'block',
        position: 'absolute',
        right: '0',
        bottom: '35%',
        zIndex: '1',
      }}
    >
      <MdNavigateNext className={classes.icon} />
    </IconButton>
  );
  const PrevArrow = ({ onClick, style }: CustomArrowProps): JSX.Element => (
    <IconButton
      className={classes.IconNavite}
      color="primary"
      onClick={onClick}
      style={{
        display: 'block',
        position: 'absolute',
        top: '35%',
        zIndex: '1',
      }}
    >
      <MdNavigateBefore className={classes.icon} />
    </IconButton>
  );

  const settings: Settings = {
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    speed: 2000,
    slidesToShow: 5,
    autoplaySpeed: 4000,
    autoplay: true,
    infinite: listApps.count > 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };
  return (
    <>
      <Box className={classes.contentLegend}>
        <div className={classes.barSeparate} />
        <Typography className={classes.textLegend}>Apps do governo</Typography>
        <div className={classes.barSeparate} />
      </Box>
      <Typography className={classes.textInfo}>Baixe nossos apps</Typography>

      <Box bgcolor={colors.colorBackground} display="flex" alignContent="center" justifyContent="center">
        {/* {showMore ? (
          <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
            <Typography className={classes.textLegend}>
              Situação 1
            </Typography>
            {listApps.results.map((app) => (
              <Card
                onMouseEnter={(): void => setAppSelected(app.id)}
                onMouseLeave={(): void => setAppSelected(null)}
                key={app.id}
                className={classes.card}
              >
                <Box
                  position="absolute"
                  height="100%"
                  width="100%"
                  display={appSelected === app.id ? 'flex' : 'none'}
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="space-around"
                  zIndex="1"
                  style={{
                    background: colors.cardAccentColor,
                  }}
                >
                  <Typography
                    style={{
                      color: colors.textBody,
                      textTransform: 'none',
                      fontSize: 14,
                    }}
                    align="center"
                  >
                    {app.nome}
                  </Typography>
                  <Box display="flex" flexDirection="column">
                    <Button
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                      onClick={(): void => (window as any).open(app.url_apple)}
                      className={classes.button}
                      style={{ display: app.url_apple ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      App Store
                    </Button>
                    <Button
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                      onClick={(): void => (window as any).open(app.url_google)}
                      className={classes.button}
                      style={{ display: app.url_google ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      Google Play
                    </Button>
                  </Box>
                </Box>
                <CardActionArea
                  style={{
                    height: '100%',
                  }}
                >
                  <CardMedia
                    style={{
                      height: '100%',
                    }}
                    image={app.url_logo}
                  />
                </CardActionArea>
              </Card>
            ))}
          </Box>
        ) : ( */}
        <div className={classes.carroselArea}>
          <Slider {...settings}>
            {listApps.results.map((app) => (
              <Card
                onMouseEnter={(): void => setAppSelected(app.id)}
                onMouseLeave={(): void => setAppSelected(null)}
                key={app.id}
                className={classes.card}
              >
                <Box
                  // position="absolute"
                  height="100%"
                  width="100%"
                  display={appSelected === app.id ? 'flex' : 'none'}
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="space-around"
                  // zIndex="1"
                  style={{
                    background: colors.cardAccentColor,
                    backgroundSize: 'cover',
                    objectFit: 'cover',
                  }}
                >
                  <Typography
                    style={{
                      color: colors.textAccentColor,
                      textTransform: 'none',
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                    align="center"
                  >
                    {app.nome}
                  </Typography>
                  <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                    <Button
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                      onClick={(): void => (window as any).open(app.url_apple)}
                      className={classes.button}
                      style={{ display: app.url_apple ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      App Store
                    </Button>
                    <Button
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                      onClick={(): void => (window as any).open(app.url_google)}
                      className={classes.button}
                      style={{ display: app.url_google ? 'block' : 'none' }}
                      variant="outlined"
                    >
                      Google Play
                    </Button>
                  </Box>
                </Box>
                <CardActionArea
                  style={{
                    height: '100%',
                  }}
                >
                  <CardMedia
                    style={{
                      height: '100%',
                      backgroundSize: 'contain',
                      width: 'auto',
                    }}
                    image={app.url_logo}
                  />
                </CardActionArea>
              </Card>
            ))}
          </Slider>
        </div>
      </Box>

    </>
  );
}
